import { Loading, QueryError } from "@/components/Loading/Loading";
import { useQuery } from "@tanstack/react-query";
import { ComunicacionAjax } from "@/ts/api/comunicacion";
import { TablaImputaciones } from "./components/TablaImputaciones";

export function ImputacionesPage() {
	return (
		<div id="content" className="content" >
			<title>Rial | Imputaciones</title>

			<div>
				<h1 style={{ marginBottom: 0 }}> Imputaciones </h1>
			</div>

			<Imputaciones />
		</div>
	);
}

function Imputaciones() {
	const queryImputaciones = useImputaciones();

	if (queryImputaciones.isPending) return <Loading />;
	if (queryImputaciones.error) return <QueryError error={queryImputaciones.error} fallback="Error al cargar las imputaciones" />;

	return (
		<TablaImputaciones imputaciones={queryImputaciones.data} />
	);
}

function useImputaciones() {
	return useQuery<Imputacion[]>({
		queryKey: ["getImputaciones"],
		queryFn: () => {
			const url = "/api/v1/imputaciones";
			return ComunicacionAjax.sendAjaxRequest<Imputacion[]>("GET", url, {});
		},
	});
}
export interface Imputacion {
	id: number;
	idArticulo: number;
	nombreArticulo: string;
	cantidad: number;
	idRepresentante: number;
	nombreRepresentante: string;
	notas: string;
	inicio: number | null;
	fin: number | null;
	fecha: number | null;
	lote: string;
	idSeccion: string;

	consumos: ComponenteConsumo[];
}


export interface ComponenteConsumo {
	idComponente: number;
	refComponente: string;
	descComponente: string;

	loteArticulo: string;
	cantidadPorUnidad: number;
	cantidadDivisor: number;
	cantidadDefectuosa: number;
	cantidadDesperdiciada: number;
}
